import { Select, ThemeContext } from 'grommet';
import { ComponentProps } from 'preact';
import { useMemo } from 'preact/hooks';

import { AgeGroup } from '@/redux/slices/user/types';

interface AgeGroupSelectorProps extends Omit<ComponentProps<typeof Select>, 'options'> {
  showUnder13Option?: boolean;
  theme?: object;
}

export const defaultTheme = {
  select: {
    container: {
      extend: {
        width: '100%',
        padding: '0',
        button: {
          borderRadius: '8px',
          '&[aria-selected="true"]': {
            color: 'white',
          },
          '&[aria-selected="true"]:hover': {
            color: 'black',
          },
        },
      },
    },
    control: {
      extend: {
        width: '100%',
        borderRadius: '8px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#E3E5E5',
        background: '#FFF',
        fontSize: '16px',
        boxSizing: 'border-box',
        padding: 0,
        fontFamily: 'inherit',
        fontWeight: 400,
      },
    },
  },
};

export const AGE_OPTIONS: { label: string; value: AgeGroup }[] = [
  { label: 'Under 13', value: 'under-13' },
  { label: '13-17', value: 'under-18-gen-z' },
  { label: '18-29', value: 'over-18-gen-z' },
  { label: '30-39', value: 'gen-y' },
  { label: '40-49', value: 'gen-y-gen-x-mix' },
  { label: '50-59', value: 'gen-x' },
  { label: '60+', value: 'boomers' },
];

const AgeGroupSelector = ({ showUnder13Option, theme, ...props }: AgeGroupSelectorProps) => {
  const options = useMemo(() => (showUnder13Option ? AGE_OPTIONS : AGE_OPTIONS.slice(1)), [showUnder13Option]);

  return (
    <ThemeContext.Extend value={theme ?? defaultTheme}>
      <Select
        name="age"
        placeholder="Age"
        labelKey="label"
        valueKey="value"
        options={options}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </ThemeContext.Extend>
  );
};

export default AgeGroupSelector;
